<div fxLayout="column">
  <div fxLayout="row" class="mb-10">
    <ng-content></ng-content>
    @if (allowSearch) {
      <abc-text-box (input)="searchTerm.next($event.target.value)" class="dl-list-search-box"
        type="text" [placeholder]="labels.Search + ' ...'" mode="search"
        (onValueChanged)="ChangeSearchValue($event.value)">
      </abc-text-box>
    }
  </div>
  <div fxLayout="row" (wheel)="onBoxScroll($event)">
    <div class="dl-list-scroll" [ngStyle]="{
        'max-height': height,
        'min-width': '100%'
      }">
      @for (item of dataSource; track identify($index, item)) {
        <div fxLayout="row" fxLayoutAlign="none center" class="dl-list-item"
          [style]="item[elementToCheck] ? customStyle : ''" (dblclick)="onRowDblClick(item)"
          >
          @if (allowMultipleSelection) {
            <abc-check-box class="dl-list-item-check" id="dl-list-item-check"
              (onValueChanged)="onItemCheckChanged($event, item.Id)" [value]="selectedDocumentsIds.includes(item.Id)">
            </abc-check-box>
          }
          <div fxFlex="30px" fxLayoutAlign="none center" id="dl-list-item-icon">
            <mat-icon [svgIcon]="getSVGIcon(item.FileName)" class="dl-list-item-icon"></mat-icon>
          </div>
        <div fxLayout="column" [fxFlex]="
            allowMultipleSelection ? 'calc(100% - 150px)' : 'calc(100% - 130px)'
          " id="dl-list-item-description">
            <div id="dl-title" class="dl-text dl-title">
              {{ item.FileName?.split(".")[0] }}
            </div>
            @if (item.FileName) {
              <div id="dl-description" class="dl-text dl-description">
                {{ item.FileName?.split(".")[1]?.toUpperCase() }}
                {{ item.Size ? "| " + item.Size : " " }}
                {{
                item.SysDateInsert
                ? "| " + (item.SysDateInsert | date: "dd.MM.yyyy")
                : " "
                }}
                {{
                item.IdRefPersonInsertFullName
                ? "| " + item.IdRefPersonInsertFullName
                : " "
                }}
                {{
                item.IdRefPersonInsertEmail
                ? "| " + item.IdRefPersonInsertEmail
                : " "
                }}
              </div>
            }
          </div>
          @if (!actionsContextMenu) {
            <div fxLayout="row" fxLayoutAlign="end center" fxFlex="100px" fxLayoutGap="5px"
              class="dl-cards-btn-container">
              @for (specificBtnItem of specificButtonsValue; track $index) {
                @if (specificBtnItem.visible) {
                  <abc-button [stylingMode]="'text'" [class]="specificBtnItem.class"
                    [hint]="specificBtnItem.text" [icon]="specificBtnItem.icon" (onClick)="specificBtnItem.onClick(item)">
                  </abc-button>
                }
              }
              @if (item.allowPreview) {
                <abc-button [stylingMode]="'text'" [hint]="labels.Preview" class="dl-preview-btn"
                  [icon]="'fullscreen'" (onClick)="previewDocument.emit(item.Id)">
                </abc-button>
              }
              @if (item.allowDownload) {
                <abc-button [stylingMode]="'text'" [hint]="labels.Download" class="dl-download-btn"
                  [icon]="'spindown'" (onClick)="downloadDocument.emit(item.Id)">
                </abc-button>
              }
              @if (item.allowDelete) {
                <abc-button [stylingMode]="'text'" [hint]="labels.Delete" class="dl-delete-btn"
                  [icon]="'remove'" (onClick)="openDeleteDocumentPopup.emit(item.Id)">
                </abc-button>
              }
              @if (item.allowDetails) {
                <abc-button [stylingMode]="'text'" [hint]="labels.Details" class="dl-details-btn"
                  [icon]="'chevronright'" (onClick)="goToDetails.emit(item.Id)">
                </abc-button>
              }
            </div>
          }
          <div>
            @if (actionsContextMenu) {
              <abc-button [stylingMode]="'text'" [hint]="labels.Actions"
            class="dl-context-menu-btn" [icon]="
              isContextMenuVisible && item.Id === selectedDocument.Id
                ? 'close'
                : 'overflow'
            " (onClick)="onOpenActionButtonsMenu($event, item)">
              </abc-button>
            }
          </div>
        </div>
      }
      @if (dataSource && dataSource?.length === 0) {
        <div fxLayout="row" fxLayoutAlign="center center" class="dl-no-data-style"
          >
          {{ labels.NoData }}
        </div>
      }
    </div>
  </div>
</div>